export const initialState = {
  email: '',
  firstName: '',
  lastName: '',
  forceChangePassword: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_GET_DONE':
      return { ...action.payload };
    default:
      return state;
  }
};

export default userReducer;
